export const CODE_THEMES = [
    {
        id: 'default',
        label: 'Default',
        character: 'The one a site ships with: deep navy in dark mode, near-white in light.',
        themes: null,
    },
    {
        id: 'plain',
        label: 'Plain',
        character: 'Almost no colour. Structure carries the code, the way a printed listing does.',
        themes: ['min-dark', 'min-light'],
    },
    {
        id: 'classic',
        label: 'Classic',
        character: 'The colours most developers already read code in, on a near-black or white page.',
        themes: ['github-dark-default', 'github-light-default'],
    },
    {
        id: 'vivid',
        label: 'Vivid',
        character: 'Warmer and more saturated; keywords, strings and types each stand apart.',
        themes: ['one-dark-pro', 'one-light'],
    },
    {
        id: 'contrast',
        label: 'High contrast',
        character: 'The strongest separation of the five, for readers who need it or ask for it.',
        themes: ['github-dark-high-contrast', 'github-light-high-contrast'],
    },
];
export const DEFAULT_CODE_THEME = 'default';
/** Reading is forgiving: a name we no longer know still builds a site. */
export function codeThemeOrDefault(value) {
    return CODE_THEMES.some((theme) => theme.id === value) ? value : DEFAULT_CODE_THEME;
}
/**
 * Writing is not. A name we do not know means the caller and this code
 * disagree about what exists, and storing the default instead hides that until
 * somebody notices their code blocks look wrong and cannot find out why — the
 * same reasoning `presetProblem` gives.
 */
export function codeThemeProblem(value) {
    if (!CODE_THEMES.some((theme) => theme.id === value)) {
        return {
            ok: false,
            problem: `"${value}" is not a code theme. Choose one of: ${CODE_THEMES.map((t) => t.id).join(', ')}.`,
        };
    }
    return { ok: true, value };
}
//# sourceMappingURL=code-themes.js.map